import { put, call, takeLatest, select, all } from 'redux-saga/effects'
import services from '../../services'
import {
  GetAllLicenses,
  GET_ALL_LICENSES,
  GET_ALL_LICENSES_ERROR,
  GET_ALL_LICENSES_SUCCESS,
} from '../types/license/get-all'
import { AssignLicense, ASSIGN_LICENSE, ASSIGN_LICENSE_ERROR, ASSIGN_LICENSE_SUCCESS } from '../types/license/assign'
import { RevokeLicense, REVOKE_LICENSE, REVOKE_LICENSE_ERROR, REVOKE_LICENSE_SUCCESS } from '../types/license/revoke'
import { GET_ALL_USERS_SUCCESS } from '../types/user/get-all'

const allUser = ({ userStore }) => userStore.all.data

function* getAllLicenses({ payload }) {
  try {
    const { response, error } = yield call(services.license.getAll, payload)
    if (error) {
      yield put({
        type: GET_ALL_LICENSES_ERROR,
        payload: error,
      })
    } else {
      yield put({
        type: GET_ALL_LICENSES_SUCCESS,
        payload: response,
      })
    }
  } catch {
    yield put({
      type: GET_ALL_LICENSES_ERROR,
      payload: 'Error al obtener licencias',
    })
  }
}

function* assignLicense({ payload }) {
  try {
    const { response, error } = yield call(services.license.assign, payload)
    if (error) {
      yield put({
        type: ASSIGN_LICENSE_ERROR,
        payload: error?.response?.status,
      })
    } else {
      const currentAllUsers = yield select(allUser)

      const updatedCurrentAllUsers = currentAllUsers[0].results.map(user => {
        if (user._id === response.user) {
          return { ...user, licenses: [response, ...user.licenses] }
        } else {
          return user
        }
      })
      yield all([
        put({
          type: ASSIGN_LICENSE_SUCCESS,
          payload: response,
        }),
        yield put({
          type: GET_ALL_USERS_SUCCESS,
          payload: [{ ...currentAllUsers[0], results: updatedCurrentAllUsers }],
        }),
      ])
    }
  } catch {
    yield put({
      type: ASSIGN_LICENSE_ERROR,
      payload: 'Error al asignar licencia',
    })
  }
}

function* revokeLicense({ payload }) {
  try {
    const { response, error } = yield call(services.license.revoke, payload)
    if (error) {
      yield put({
        type: REVOKE_LICENSE_ERROR,
        payload: error?.response?.status,
      })
    } else {
      const currentAllUsers = yield select(allUser)

      const updatedCurrentAllUsers = currentAllUsers[0].results.map(user => {
        if (user._id === payload.user) {
          return {
            ...user,
            licenses: user.licenses.map(license => {
              if (license?._id === response?._id) {
                return response
              }

              return license
            })
          }
        } else {
          return user
        }
      })

      yield all([
        put({
          type: REVOKE_LICENSE_SUCCESS,
          payload: response,
        }),
        yield put({
          type: GET_ALL_USERS_SUCCESS,
          payload: [{ ...currentAllUsers[0], results: updatedCurrentAllUsers }],
        }),
      ])
    }
  } catch {
    yield put({
      type: REVOKE_LICENSE_ERROR,
      payload: 'Error al revocar licencia',
    })
  }
}

/**
 * Watchers
 */
export default function* applicant() {
  yield takeLatest<GetAllLicenses>(GET_ALL_LICENSES, getAllLicenses)
  yield takeLatest<AssignLicense>(ASSIGN_LICENSE, assignLicense)
  yield takeLatest<RevokeLicense>(REVOKE_LICENSE, revokeLicense)
}
